import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../../../auth/service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { IContentHeader } from "../../../../../layout/components/content-header/content-header.component";
import { InvoiceService } from "../../../invoice.service";
import { ICustomer } from "../../../../customer/customer.interface";
import { CustomerService } from "../../../../customer/customer.service";
import moment from "moment";
import { ListService } from "../../../../../auth/service/list.service";
import { catchError, tap } from "rxjs/operators";

@Component({
  selector: "app-invoice-completed",
  templateUrl: "./invoice-completed.component.html"
})
export class InvoiceCompletedComponent implements OnInit {
  tableLimit: number = 10;
  searchKeyword: string = "";
  contentHeader: IContentHeader;
  listElements: any[] = [];
  filteredListElements: any[] = [];
  filterStatus: string = "";
  customers: ICustomer[] = [];
  filterCustomer: { id: number; name: string; } = { id: null, name: null };
  filterInvoiceType: { id: number; name: string; } = { id: null, name: null };
  invoiceSelectedId: number | null = null;
  invoice_document_types: any = [];
  credit_notes_types_ids = [];

  filterYear: number = moment().year();
  years = Array.from({ length: this.filterYear - 2024 + 2 }, (v, i) => 2024 + i);

  filterMonth: number = -1;
  months = moment.months().map((month: string) => month[0].toUpperCase() + month.substr(1));
  sumTotalsAmount: number = 0;

  filterResource: string = "all";

  isMenuToggled = false;

  apexLineChart: any;
  chartData;
  balancePercentage = {
    icon: "up",
    color: "success",
    number: 0
  };
  chartTotal = 0;
  invoices_with_errors: number[] = [];


  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    public _invoiceService: InvoiceService,
    private _customerService: CustomerService,
    private _listService: ListService
  ) {
    this.contentHeader = {
      headerTitle: "MENU.INVOICES_COMPLETED",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.INVOICES",
            isLink: false
          },
          {
            name: "MENU.INVOICES_COMPLETED",
            isLink: false
          }
        ]
      }
    };

    this.apexLineChart = {
      chart: {
        height: 400,
        type: "line",
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        }
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        }
      },
      markers: {
        strokeWidth: 7,
        strokeOpacity: 1,
        strokeColors: ["#fff"],
        colors: ["#FF9F43"]
      },
      colors: ["#FF9F43"],
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "straight"
      },
      xaxis: {
        categories: this.months
      },
      yaxis: {
        labels: {
          formatter: (value: any) => (value / 1000).toFixed(0) + "k"
        }
      },
      tooltip: {
        custom: ({ series, seriesIndex, dataPointIndex }) => `<div class="px-1 py-50">
<span>${series[seriesIndex][dataPointIndex].toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}&euro;</span>
</div>`
      }
    };

  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_invoice_completed")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.customers = await this._customerService.getCustomers();
    this._listService.getList("invoice_document_type").then((result: any) => {
      this.invoice_document_types = result;
      this.credit_notes_types_ids = result.filter((result: any) => result.other.credit_note).map((result: any) => result.id);
    });
    this.load();
  }

  load() {
    this._utilService.showLoading();
    const today = moment();
    this._invoiceService.getCompleted(this.filterYear).subscribe((data) => {
      this.listElements = data.map((item: any) => ({ ...item, expired: moment(item.expiration_date).isBefore(today) }));
      this.filter();
      this._utilService.hideLoading();
    });
  }

  syncPayedInvoices() {
    this._utilService.showLoading();
    this._invoiceService.syncPayed()
      .pipe(
        tap((result: { invoices_error: string[], message: string }) => {
          if (result.invoices_error.length) {
            this.invoices_with_errors = result.invoices_error.map((id) => Number(id));
            this._utilService.showToastrError("ERROR_SYNC_CASHED_INVOICE");
          } else {
            this._utilService.showToastrSuccess("SUCCESS_SYNC_CASHED_INVOICE");
          }
          return result;
        }),
        catchError(() => this._utilService.showToastrError("ERROR_SYNC_CASHED_INVOICE"))
      )
      .subscribe(() => {
        this.load();
        this.filter();
        this._utilService.hideLoading();
      });
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  filter() {
    let items: any[] = this.listElements;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) =>
        item.id.toString().includes(keywords) ||
        (item.document_number || "").toLowerCase().includes(keywords) ||
        (item.order_number || "").toLowerCase().includes(keywords) ||
        (item.client && item.client.name && item.client.name.toLowerCase().includes(keywords)) ||
        (item.users_in_rows || []).join(",").toLowerCase().includes(keywords) ||
        (item.products_in_rows || []).join(",").toLowerCase().includes(keywords) ||
        (item.rows || [])[0]?.description?.toLowerCase().includes(keywords)
      );
    }

    const month = Number(this.filterMonth);
    if (month > -1) {
      items = items.filter((item: any) => moment(item.document_date).month() === month);
    }

    if (this.filterStatus && this.filterStatus.length > 0) {
      if (this.filterStatus === "expired") {
        items = this.listElements.filter((item: any) => !item.cashed && item.expired);
      } else if (this.filterStatus === "not_cashed") {
        items = this.listElements.filter((item: any) => !item.cashed && !item.expired);
      } else if (this.filterStatus === "cashed") {
        items = this.listElements.filter((item: any) => item.cashed);
      }
    }

    if (this.filterResource === "employee") {
      items = items.filter((item: any) => item.users_in_rows.length > 0);
    } else if (this.filterResource === "product") {
      items = items.filter((item: any) => item.products_in_rows.length > 0);
    }

    items = items.map((item: any) => ({ ...item, users_names_in_rows: Array.from(new Set(item.users_in_rows)) }));

    if (!!this.filterCustomer?.id) {
      const customer_id = Number(this.filterCustomer.id);
      items = items.filter((item) => Number(item.client.id) === customer_id);
    }

    if (!!this.filterInvoiceType?.id) {
      const type_id = Number(this.filterInvoiceType.id);
      items = items.filter((item) => Number(item.invoice_type.id) === type_id);
    }

    items = items.map((item: any) => ({ ...item, document_number: item.document_number || item.id }));

    const invoicesAmount = items
      .filter((item: any) => !this.credit_notes_types_ids.includes(item.invoice_type.id))
      .map((item: any) => Number(item.total_amount))
      .reduce((sum: number, total: number) => Number(sum) + Number(total), 0);

    const creditNotesAmount = items
      .filter((item: any) => this.credit_notes_types_ids.includes(item.invoice_type.id))
      .map((item: any) => Number(item.total_amount))
      .reduce((sum: number, total: number) => Number(sum) + Number(total), 0);

    this.sumTotalsAmount = invoicesAmount - creditNotesAmount;

    this.filteredListElements = items;

    this.filterForChart();
  }

  filterForChart() {

    let graphicData = this.listElements;

    if (!!this.filterCustomer?.id) {
      const customer_id = Number(this.filterCustomer.id);
      graphicData = graphicData.filter((item) => Number(item.client.id) === customer_id);
    }

    if (this.filterResource === "employee") {
      graphicData = graphicData.filter((item: any) => item.users_in_rows.length > 0);
    } else if (this.filterResource === "product") {
      graphicData = graphicData.filter((item: any) => item.products_in_rows.length > 0);
    }

    this.chartData = [];

    for (let i = 0; i < 12; i++) {

      const invoicesAmount = graphicData
        .filter((item: any) => !this.credit_notes_types_ids.includes(item.invoice_type.id) && moment(item.document_date).month() === i)
        .map((item: any) => Number(item.total_amount))
        .reduce((sum: number, total: number) => Number(sum) + Number(total), 0);

      const creditNotesAmount = graphicData
        .filter((item: any) => this.credit_notes_types_ids.includes(item.invoice_type.id) && moment(item.document_date).month() === i)
        .map((item: any) => Number(item.total_amount))
        .reduce((sum: number, total: number) => Number(sum) + Number(total), 0);

      const amount = invoicesAmount - creditNotesAmount;

      this.chartData.push(Number(amount.toFixed(2)));
    }

    this.chartTotal = this.chartData.reduce((acc, curr) => acc + curr, 0);

    const amountCurrentMonth = this.chartData[moment().month()];
    const amountLastMonth = this.chartData[moment().month() - 1];

    this.balancePercentage.number = this._utilService.calculatePercentageBetweenTwoNumbers(amountCurrentMonth, amountLastMonth);

    if (this.balancePercentage.number < 0) {
      this.balancePercentage.color = "danger";
      this.balancePercentage.icon = "down";
    } else {
      this.balancePercentage.color = "success";
      this.balancePercentage.icon = "up";
    }
  }
}
